import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Input } from 'reactstrap';
import { saveAuthUser, removeAuthUser } from '../../../../actions/authUserAction';
import {isMobile} from 'react-device-detect';

import InlineEdit from '../../../../components/InlineEdit/InlineEdit';
import AuthorizedUser from '../../../../components/AuthorizedUser/AuthorizedUser';
import StaticField from '../../../../components/StaticField/StaticField';
import SaveDialog from '../../../../components/SaveDialog/SaveDialog';

import { AUTHUSER } from '../../../../utils/FieldTypes';

import moment from 'moment';

class InlineEditAuthUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: false,
      saveDialogOpen: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.validateField = this.validateField.bind(this);
    this.onClickSave = this.onClickSave.bind(this);
    this.toggleEdit = this.toggleEdit.bind(this);
    this.cancelEdit = this.cancelEdit.bind(this);
    this.removeAuthUser = this.removeAuthUser.bind(this);
    this.toggleSaveDialog = this.toggleSaveDialog.bind(this);
  }
  handleChange(event) {
    this.props.handleChange(AUTHUSER, event);
  }
  validateField(event) {
    this.props.validateField(AUTHUSER, event);
  }

  onClickSave(event) {
    event.preventDefault();
    let validation = this.props.validation;
    // PBI 441340 VOA: Set 'Email' as a required field and add it to the Authorized User form
    // PBI 441341 VOA: Replace the drop-down for the Primary and Authorized User Phone fields with two separate input fields for Mobile and Home phone numbers
    let authUser = {firstName: this.props.firstName, lastName: this.props.lastName, birthdate: this.props.birthdate, mobilePhone: this.props.mobilePhone, homePhone: this.props.homePhone, email: this.props.email, address1: this.props.address1, address2: this.props.address2, city: this.props.city, province: this.props.province, postalCode: this.props.postalCode, manualEntry: this.props.manualEntry, sameAsMyAddress: this.props.sameAsMyAddress, status: this.props.status, industry: this.props.industry, occupationName: this.props.occupationName, noc:this.props.noc };
    validation =  this.props.validator.validate(authUser);
    if(!this.props.manualEntry) {
      validation = {...validation,
          homeAddress: {
            isInvalid: true,
            message: "Oops, home address is a required field"
          }
        };
        validation.isValid = false
    }

    this.props.updateValidation(validation, this.props.index);
    
    if(validation.isValid) {
      this.props.saveAuthUser({id: this.props.id, ...authUser}, this.props.index);
      this.toggleEdit();
    }
    else {
      this.setState({
        saveDialogOpen: false
      })
    }
  }
  toggleEdit() {    
    this.props.updateFieldsFromSavedState(AUTHUSER, this.props.index);
    this.props.countOpenSections(!this.state.edit);
    this.setState({
      edit: !this.state.edit,
      saveDialogOpen: false
    });
  }
  cancelEdit() {
    if( this.props.firstName === this.props.savedAuthUser.firstName &&
        this.props.lastName === this.props.savedAuthUser.lastName &&
        this.props.birthdate === this.props.savedAuthUser.birthdate &&
    // PBI 441340 VOA: Set 'Email' as a required field and add it to the Authorized User form
    // PBI 441341 VOA: Replace the drop-down for the Primary and Authorized User Phone fields with two separate input fields for Mobile and Home phone numbers
        this.props.mobilePhone === this.props.savedAuthUser.mobilePhone &&
        this.props.homePhone === this.props.savedAuthUser.homePhone &&
        this.props.email === this.props.savedAuthUser.email &&
        this.props.address1 === this.props.savedAuthUser.address1 &&
        this.props.address2 === this.props.savedAuthUser.address2 &&
        this.props.city === this.props.savedAuthUser.city &&
        this.props.province === this.props.savedAuthUser.province &&
        this.props.postalCode === this.props.savedAuthUser.postalCode &&
        this.props.manualEntry && 
        this.props.status === this.props.savedAuthUser.status && 
        this.props.industry === this.props.savedAuthUser.industry && 
        this.props.occupationName === this.props.savedAuthUser.occupationName && 
        this.props.noc === this.props.savedAuthUser.noc) {
      this.toggleEdit();
    }
    else {
      this.setState({
        saveDialogOpen: true
      })
    }
  }
  removeAuthUser(index) {
    this.props.countOpenSections(false);
    this.props.removeUser(index);
    this.props.removeAuthUser(this.props.index);
  }
  toggleSaveDialog() {
    this.setState({
      saveDialogOpen: !this.state.saveDialogOpen
    });
  }
  render() {
    let formattedDate = "";

    if(this.props.savedAuthUser.birthdate !== undefined) {
      formattedDate = moment(this.props.savedAuthUser.birthdate).format("MMM D YYYY");
    }

    let address = `${this.props.savedAuthUser.address1}, ${(this.props.savedAuthUser.address2 !== "") ? this.props.savedAuthUser.address2 + ', ' : ""}${this.props.savedAuthUser.city}, ${this.props.savedAuthUser.province}, ${this.props.savedAuthUser.postalCode}`;
    
    let statusLabel = this.props.savedAuthUser.status;
    if(this.props.savedAuthUser.status === "SelfEmployed") {
      statusLabel = "Self-Employed";
    }
    else if(this.props.savedAuthUser.status === "SocialAssit") {
      statusLabel = "On disability assistance";
    }
    return (
      <div className="review-inline-edit"> 
        {!this.state.edit ?   
          <StaticField onClickEdit={this.toggleEdit} hidden={this.state.edit} disableEdit={this.props.sectionsOpen}>
            <Input plaintext value={`${this.props.savedAuthUser.firstName} ${this.props.savedAuthUser.lastName}`} readOnly />
            <Input plaintext value={`Born: ${formattedDate}`} readOnly />
            <Input plaintext value={address} readOnly />
            {/* PBI 441340 VOA: Set 'Email' as a required field and add it to the Authorized User form */}
            {/* PBI 441341 VOA: Replace the drop-down for the Primary and Authorized User Phone fields with two separate input fields for Mobile and Home phone numbers */}
            <Input plaintext value={`Mobile Phone: ${this.props.savedAuthUser.mobilePhone}`} readOnly />
            <Input plaintext value={`Home Phone: ${this.props.savedAuthUser.homePhone}`} readOnly />
            <Input plaintext value={`Email: ${this.props.savedAuthUser.email}`} readOnly />
          </StaticField>
        :
          <InlineEdit onClickSave={this.onClickSave} hidden={!this.state.edit} onClickCancel={this.cancelEdit}>  
            <AuthorizedUser  
              index={this.props.index}
              authUser={this.props.authUser} 
              removeText="Remove this user"
              updateAuthUser={this.props.updateAuthUser} 
              saveAuthUser={this.onClickSave}
              removeAuthUser={this.removeAuthUser}
              resetAuthUserFieldValidation={this.props.resetAuthUserFieldValidation}
              validation={this.props.validation}
              resetAddressFieldValidation={this.props.resetAuthUserAddressFieldValidation}
              validateField={this.props.validateField}
              address={this.props.personalInfo.address}
              autoFocus={!isMobile} />
          </InlineEdit>
        }
        <SaveDialog visible={this.state.saveDialogOpen} toggle={this.toggleSaveDialog} name="Authorized User" onClickSave={this.onClickSave} onClickCancel={this.toggleEdit} />
      </div>);
  }
}

const mapStateToProps = state => ({
  personalInfo: state.personalInfo,
})

const mapDispatchToProps = dispatch => ({
  saveAuthUser: (authUser, index) => dispatch(saveAuthUser(authUser, index)),
  removeAuthUser: (index) => dispatch(removeAuthUser(index))
})

export default connect(mapStateToProps, mapDispatchToProps)(InlineEditAuthUser);


// WEBPACK FOOTER //
// ./src/containers/Review/InlineEdit/AuthUsers/AuthUser.js